export enum ViteEnvironment {
  Test = 'test',
  Mock = 'mock',
  Prod = 'prod',
}
